// extracted by mini-css-extract-plugin
export default {"Accordion":"AccordionAfinando_Accordion__dzucP","Title":"AccordionAfinando_Title__aAKMo","Description":"AccordionAfinando_Description__jySch"};